import React, { useState } from 'react'
import { useToast } from '../../lib/ui/toast'
import Spinner from '../shared/Spinner'
import { apiPost } from '../../util/api'
import { useDropzone } from 'react-dropzone'
import { cn } from '../../lib/utils'

const DropzoneResumeUpload = ({ className, helpText }) => {
  const [resumeIsUploading, setResumeIsUploading] = useState(false)
  const [isDraggingOver, setIsDraggingOver] = useState(false)
  const { toast } = useToast()
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    accept: {
      '*/*/pdf': ['.pdf'],
      '*/*/msword': ['.doc'],
      '*/*/document': ['.docx'],
    },
    onDropAccepted: (incomingFiles) => saveNewResume(incomingFiles[0]),
    onDropRejected: (incomingFiles) => rejectionMessage(incomingFiles),
    onDragEnter: () => setIsDraggingOver(true),
    onDragLeave: () => setIsDraggingOver(false),
    onDrop: () => setIsDraggingOver(false),
    maxSize: 15_000_000, // 15MB
    disabled: resumeIsUploading,
  })

  const rejectionMessage = (incomingFiles) => {
    const {
      file: { type },
      errors,
    } = incomingFiles[0]
    const description = errors.map((e) => ` • ${e.message}`).join('\n')
    console.error('File upload rejected:', description)
    if (type) {
      toast({
        description,
        title: 'Could Not Upload Resume',
        variant: 'destructive',
        duration: 10_000,
      })
    }
  }

  const saveNewResume = async (file) => {
    setResumeIsUploading(true)
    const name = file.name.split('.')[0]
    const lastModified = file.lastModifiedDate.toISOString()
    const formData = new FormData()
    formData.append('imported_resume', file)
    formData.append('revision_date', lastModified)
    formData.append('name', name)
    // get the candidate ID from the URL and append to formData
    const candidateId = window.location.pathname
      .split('/')
      .pop()
      .match(/^\d+/)?.[0]
    formData.append('candidate_id', candidateId)

    try {
      await apiPost('/resume/builder', formData, true)
      setResumeIsUploading(false)
      toast({ description: 'Resume uploaded successfully' })
      // set the window location to the current url with a tab param of settings_and_documents
      window.location.href = `${window.location.pathname}?active_tab=settings_and_documents`
    } catch (e) {
      setResumeIsUploading(false)
      console.error('Error saving new resume', e)
      toast({
        description: 'Error: Resume upload failed.',
        variant: 'destructive',
      })
      return
    }
  }

  const baseRootClassName = cn(
    'min-h-[20rem] p-4 border-dashed border text-center content-center justify-items-center',
    className,
  )
  const defaultRootClassName = isDraggingOver
    ? baseRootClassName + ' border-primary border-2 bg-lily-blue'
    : baseRootClassName
  const rootClassName = resumeIsUploading
    ? defaultRootClassName
    : defaultRootClassName + ' cursor-pointer'

  return (
    <div className="px-4 pb-4">
      <div
        {...getRootProps({
          className: rootClassName,
        })}
      >
        <input {...getInputProps()} />
        {resumeIsUploading && <Spinner show={true} className="w-14" />}
        {!resumeIsUploading && (
          <div>
            <p>
              {helpText || `Drag and drop your resume here, or click to select`}
            </p>
            <em>(Files must be in .pdf, .doc, or .docx format)</em>
          </div>
        )}
      </div>
    </div>
  )
}
export default DropzoneResumeUpload
